import React from 'react';
import { motion } from 'framer-motion';
export function Slide01Cover() {
  return <div className="flex flex-col items-center justify-center h-full text-center relative z-10" data-id="element-29">
      <div className="bg-white/5 backdrop-blur-sm p-16 rounded-3xl border border-white/10 shadow-2xl max-w-5xl w-full" data-id="element-30">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.8
      }} data-id="element-31">
          <h1 className="text-6xl md:text-8xl font-bold text-[#ffd700] mb-6 tracking-tight" data-id="element-32">
            Sampler Solutions
          </h1>

          <div className="h-1 w-32 bg-[#4fd1c5] mx-auto mb-8 rounded-full" data-id="element-33" />

          <p className="text-2xl md:text-3xl text-white/90 font-light mb-12 leading-relaxed" data-id="element-34">
            The Future of Sampling, Brand Engagement <br data-id="element-35" />& Real‑World
            Activations
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-36">
            {['Finns i Sjön', 'SponsrAI', 'Co‑Brand Sampling™'].map((item, i) => <motion.div key={item} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + i * 0.1
          }} className="p-4 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center gap-3" data-id="element-37">
                  <div className="w-2 h-2 rounded-full bg-[#ffd700]" data-id="element-38" />
                  <span className="font-medium text-[#4fd1c5]" data-id="element-39">{item}</span>
                </motion.div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}